// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1MjUl","spin":"Loader_spin__3pTHl"};